import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Switch from '@material-ui/core/Switch';
import GenPdf from '../GenPdf';
import Header from '../Header/Header';
import NumDossFacAmendment from '../NumDossFacAmendment';
import DocMenu from "../DocMenu";
import { fetchAllFacAmendment, fetchFacAmendmentByDossIndex, changeFacAmendmentNumber } from "../../redux/actions/facAmendmentActions";
import { fetchAllFacAmendmentReminder } from "../../redux/actions/reminderFacAmendmentActions";
import FacAmendmentReminderDetail from "./FacAmendmentReminder/FacAmendmentReminderDetail";
import { changeTitleName, changePdfFileName } from "../../redux/actions/emailAction";
import { getContact, getEch } from '../Factures/Utils';
import { getRefFacture, genFacAmendmentReminder, getFacAmendmentReminder, genFacAmendmentReminderTable, getFacAmendmentReminderTable, getAmendmentLetter } from './Utils';
import "../../Styles/FactureAmendment/FacAmendmentReminder.scss";


const FacAmendmentReminder = () => {
  const dispatch = useDispatch();

  const factures = useSelector(state => state.facture.allfacture);
  const deviscon = useSelector(state => state.devis.deviscon);
  const dossierValue = useSelector(state => state.devis.dossierValue);
  const dossiers = useSelector(state => state.dossier.items);
  const contact = useSelector(state => state.contact.items);
  const echeances = useSelector(state => state.echeances.items);
  const facAmendments = useSelector(state => state.facAmendment.facAmendments);
  const facAmendmentsByDossIndex = useSelector(state => state.facAmendment.facAmendmentsByDossIndex);
  const contractFacAmendmentIndex = useSelector(state => state.facAmendment.contractFacAmendmentIndex);
  const facAmendmentIndex = useSelector(state => state.facAmendment.facAmendmentIndex);
  const reminders = useSelector(state => state.reminderFacAmendment.items);

  const [dataFacture, setDataFacture] = useState({ date_ech: new Date() });
  const [maitreOuvrage, setMaitreOuvrage] = useState({});
  const [first_reminder, setFirstReminder] = useState(true);
  const [disableButton, setDisableButton] = useState(false);
  const [clientResponse, setClientResponse] = useState(false);
  const [comptableSexe, setComptableSexe] = useState("male");
  const [comptableName, setComptableName] = useState("");
  const [avenantEcheance, setAvenantEcheance] = useState({});
  const [file, setFile] = useState(null);
  const [openFile, setOpenFile] = useState(false);

  const indexAmendmentLetter = getAmendmentLetter(contractFacAmendmentIndex);

  useEffect(() => {
    const initialize = async () => {
      dispatch(changePdfFileName(""));
      await dispatch(fetchAllFacAmendment());
      await dispatch(fetchAllFacAmendmentReminder());

      if (dossierValue && contractFacAmendmentIndex) {
        if (echeances) {
          const avenantEch = await getEch(echeances, dossierValue);
          setAvenantEcheance(avenantEch);
        }
        await dispatch(fetchFacAmendmentByDossIndex(dossierValue, contractFacAmendmentIndex));
        await dispatch(changeFacAmendmentNumber(facAmendmentIndex));
        loadData();
      }
    };
    initialize();
  }, []);

  useEffect(() => {
    const updateDossier = async () => {
      if (dossierValue) {
        await dispatch(fetchFacAmendmentByDossIndex(dossierValue));
      }
    };
    updateDossier();
  }, [dossierValue]);

  useEffect(() => {
    const updateEcheances = async () => {
      if (dossierValue && echeances) {
        const avenantEch = await getEch(echeances, dossierValue);
        setAvenantEcheance(avenantEch);
      }
    };
    updateEcheances();
  }, [dossierValue, echeances]);

  useEffect(() => {
    if (facAmendmentIndex || facAmendmentsByDossIndex) {
      loadData();
    }
  }, [facAmendmentIndex, facAmendmentsByDossIndex]);

  useEffect(() => {
    setFile(null);
  }, [first_reminder]);

  const safeParseJson = (value) => {
    if (typeof value === "string") {
      try {
        return JSON.parse(value);
      } catch (e) {
        console.error("Erreur de parsing JSON:", e);
        return value;
      }
    }
    return value;
  };

  const loadData = () => {
    dispatch(changePdfFileName(""));
    const maitre = getContact(dossiers, contact, dossierValue);
    let dataFac = facAmendmentIndex > 0 && facAmendmentIndex <= facAmendmentsByDossIndex.length
      ? { ...facAmendmentsByDossIndex[facAmendmentIndex - 1] }
      : { date_ech: new Date() };

    if (dataFac.dossier !== undefined && dataFac.dossier !== null) {
      dataFac.dossier = safeParseJson(dataFac.dossier);

      if (Object.keys(dataFac.dossier).length > 4) {
        dataFac.date_reminder = new Date().toLocaleDateString('en-CA');

        const tva = parseFloat(dataFac.tva) || 0;
        dataFac.total_tva = parseFloat((dataFac.total_ht * (tva / 100)).toFixed(2));
        dataFac.total_ttc = parseFloat((dataFac.total_ht * (1 + tva / 100)).toFixed(2));
      }
    }

    setDataFacture(dataFac);
    setMaitreOuvrage(maitre);
    setFile(null);
  };

  const handleDateReminderChange = (date) => {
    const updatedDataFacture = { ...dataFacture };
    updatedDataFacture.date_reminder = date;
    setDataFacture(updatedDataFacture);
    setComptableSexe("male");
    setComptableName("");
  };

  const handleChangeSwitch = () => {
    setFirstReminder(!first_reminder);
    setClientResponse(false);
  };

  const handleChangeClientResponse = (response) => {
    setClientResponse(response);
  };

  const handleChangeCompatbleInfos = (event) => {
    const { name, value } = event.target;
    if (name === 'comptableSexe') {
      setComptableSexe(value);
    } else if (name === 'comptableName') {
      setComptableName(value);
    }
  };

  const getSignatureDate = (numdossier) => {
    const firstFacture = factures.find(fac => fac.ndossier === numdossier && fac.numclient.includes('C1'));
    return new Date(firstFacture.date_ech).toLocaleDateString('en-CA');
  };

  const getFirstReminder = (numclient) => {
    const firstDateReminder = reminders.find(r => r.numclient === numclient && r.first_reminder === 1);
    return firstDateReminder !== undefined
      ? new Date(firstDateReminder.date_reminder).toLocaleDateString('en-CA')
      : "";
  };

  const getDevisCon = () => {
    const arr = deviscon.filter(item => item.ndossier == dossierValue);
    const max = Math.max.apply(Math, arr.map((item) => item.iddeviscon));
    return arr.find(item => item.iddeviscon == max) || "";
  };

  const formatDate = (inputDate) => {
    if (inputDate === null || inputDate === "") {
      return "";
    }
    const parts = inputDate.split('-');
    const formattedDate = `${parts[2]}/${parts[1]}/${parts[0]}`;
    return formattedDate;
  };

  const getAllReminders = () => {
    let filteredAndCalculatedData = [];
    let clientData = {};

    reminders.forEach((item) => {
      if (item.ndossier === dossierValue && item.amendment_number == contractFacAmendmentIndex) {
        const numclient = item.numclient;

        if (!clientData[numclient]) {
          clientData[numclient] = {
            nfacture: "",
            date_ech: "",
            first_reminder: "",
            second_reminder: "",
            date_first_reminder: "",
            date_second_reminder: "",
            validation: facAmendments.filter((element) => element.numclient === numclient)[0].payment_date,
          };
        }
        clientData[numclient].nfacture = `${(item.nfacture).replace(' ', `/${indexAmendmentLetter}-`)} ${getRefFacture(item.numclient)}`;

        if (!clientData[numclient].date_ech) {
          clientData[numclient].date_ech = new Date(item.date_ech).toLocaleDateString('en-CA');
        }

        if (item.first_reminder === 1) {
          const first_rem = new Date(clientData[numclient].date_ech);
          first_rem.setDate(first_rem.getDate() + 15);
          clientData[numclient].first_reminder = first_rem.toLocaleDateString('en-CA');
          clientData[numclient].date_first_reminder = new Date(item.date_reminder).toLocaleDateString('en-CA');
        }

        if (item.first_reminder === 0) {
          const second_rem = new Date(clientData[numclient].date_ech);
          second_rem.setDate(second_rem.getDate() + 30);
          clientData[numclient].second_reminder = second_rem.toLocaleDateString('en-CA');
          clientData[numclient].date_second_reminder = new Date(item.date_reminder).toLocaleDateString('en-CA');
        } else if (!clientData[numclient].second_reminder) {
          clientData[numclient].second_reminder = "";
          clientData[numclient].date_second_reminder = "";
        }
      }
    });

    for (const numclient in clientData) {
      if (clientData.hasOwnProperty(numclient)) {
        const clientInfo = clientData[numclient];
        filteredAndCalculatedData.push({
          numclient: numclient,
          nfacture: clientInfo.nfacture,
          date_ech: formatDate(clientInfo.date_ech),
          first_reminder: formatDate(clientInfo.first_reminder),
          date_first_reminder: formatDate(clientInfo.date_first_reminder),
          second_reminder: clientInfo.second_reminder !== "" ? formatDate(clientInfo.second_reminder) : "",
          date_second_reminder: clientInfo.date_second_reminder !== "" ? formatDate(clientInfo.date_second_reminder) : "",
          validation: clientInfo.validation !== null ? formatDate(clientInfo.validation.slice(0, 10)) : ""
        });
      }
    }
    filteredAndCalculatedData.sort((a, b) => a.numclient.localeCompare(b.numclient));
    return filteredAndCalculatedData;
  };

  const handleSaveData = async () => {
    setDisableButton(true);
    const date_ech = new Date(dataFacture.date_ech).toLocaleDateString('en-CA');
    const json = {
      ndossier: dataFacture.ndossier,
      amendment_index: contractFacAmendmentIndex,
      numclient: dataFacture.numclient,
      nfacture: dataFacture.nfacture,
      date_ech: date_ech,
      idcontact: maitreOuvrage.idcontact,
      company: dataFacture.dossier.sci_sccv,
      date_reminder: dataFacture.date_reminder,
      amount_ht: dataFacture.total_ht,
      amount_tva: dataFacture.total_tva,
      amount_ttc: dataFacture.total_ttc,
      first_reminder: first_reminder,
      client_response: clientResponse
    };

    const requestOptions = {
      method: "POST",
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(json)
    };

    await fetch("/api/facamendment/saveFacAmendmentReminder", requestOptions)
      .catch((err) => {
        console.log(err);
      });
    await dispatch(fetchAllFacAmendmentReminder());
    setDisableButton(false);
  };

  const handleGenFacAmendmentReminder = async () => {
    setFile(null);
    setDisableButton(true);

    const json = {
      ndossier: dataFacture.ndossier,
      amendment_index: contractFacAmendmentIndex,
      numclient: dataFacture.numclient,
      nfacture: dataFacture.nfacture,
      ref_facture: getRefFacture(dataFacture.numclient),
      date_ech: new Date(dataFacture.date_ech).toLocaleDateString('en-CA'),
      date_signature: getSignatureDate(dataFacture.ndossier),
      maitre_ouvrage: maitreOuvrage,
      operation: dataFacture.dossier.operation,
      sci_sccv: dataFacture.dossier.sci_sccv,
      operation_adress: dataFacture.dossier.adresse_op + ", " + dataFacture.dossier.cp_op + " - " + dataFacture.dossier.ville_op,
      date_reminder: dataFacture.date_reminder,
      amount_ht: dataFacture.total_ht,
      first_reminder: first_reminder,
      client_response: clientResponse,
      ndossier_: dataFacture.ndossier.toString().split('').join('-'),
      nprop: getDevisCon().nprop.toString().length === 1 ? "0" + getDevisCon().nprop : getDevisCon().nprop,
      date_contrat: avenantEcheance.datepgcp,
      date_first_reminder: getFirstReminder(dataFacture.numclient),
      comptable: `${comptableSexe === "male" ? "mon collaborateur" : "ma collaboratrice"} ${comptableName}`
    };

    const requestOptions = {
      method: "POST",
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(json)
    };

    let blob = await genFacAmendmentReminder(requestOptions);
    await handleSaveData();
    if (blob) {
      setFile(blob);
      setDisableButton(false);
      setOpenFile(true);
    }
  };

  const handleShowFacAmendmentReminder = async () => {
    setFile(null);
    setDisableButton(true);

    let response = await getFacAmendmentReminder(dossierValue, contractFacAmendmentIndex, first_reminder, getRefFacture(dataFacture.numclient), 'pdf');

    if (response.blob.size > 100) {
      setFile(response.blob);
      setOpenFile(true);

      const fileName = response.fileName;
      dispatch(changePdfFileName(fileName));
    }
    setDisableButton(false);
  };

  const handleGetPdfFile = async () => {
    setFile(null);

    let response = await getFacAmendmentReminder(dossierValue, contractFacAmendmentIndex, first_reminder, getRefFacture(dataFacture.numclient), 'pdf');

    if (response.blob.size > 100) {
      setFile(response.blob);

      const fileName = response.fileName;
      dispatch(changePdfFileName(fileName));
    }
  };

  const handleGetWordFile = async () => {
    setFile(null);

    let response = await getFacAmendmentReminder(dossierValue, contractFacAmendmentIndex, first_reminder, getRefFacture(dataFacture.numclient), 'word');

    if (response.blob.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document') {
      setFile(response.blob);

      const fileName = response.fileName;
      dispatch(changePdfFileName(fileName));
    }
  };

  const handleGenFacAmendmentReminderTable = async () => {
    setFile(null);
    setDisableButton(true);

    const data = getAllReminders();

    const json = {
      ndossier: dataFacture.ndossier,
      amendment_index: contractFacAmendmentIndex,
      ref_facture: getRefFacture(dataFacture.numclient),
      maitre_ouvrage: maitreOuvrage,
      dossier: dataFacture.dossier,
      date_table: new Date(),
      data
    };

    const requestOptions = {
      method: "POST",
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(json)
    };

    let blob = await genFacAmendmentReminderTable(requestOptions);
    if (blob) {
      setFile(blob);
    }
    setDisableButton(false);
    setOpenFile(true);
  };

  const handleShowFacAmendmentReminderTable = async () => {
    setFile(null);
    setDisableButton(true);
    let blob = await getFacAmendmentReminderTable(dossierValue, contractFacAmendmentIndex);
    if (blob) {
      setFile(blob.size > 100 ? blob : null);
      setOpenFile(blob.size > 100 ? true : false);
    }
    setDisableButton(false);
  };

  const closeDoc = () => {
    setOpenFile(false);
  };

  const handleChangeTitleName = () => {
    dispatch(changeTitleName(`Relance Facture Avenant ${indexAmendmentLetter}R${facAmendmentIndex}`));
  };

  const dataLoaded = Object.keys(dataFacture).length > 1;

  return (
    <div className="reminder-fac-amendment">
      <Header />
      <DocMenu
        file={file}
        getSourceFile={handleGetWordFile}
        getPDF={handleGetPdfFile}
        handleChangeTitleName={handleChangeTitleName}
      />
      <NumDossFacAmendment type="facAmendment" />
      <h1 className="title">
        Relance Facture Avenant
      </h1>
      {dataLoaded && (
        <div className="switch-reminder">
          <span className={first_reminder ? "active1" : "no-active"}>1<sup>ère </sup>Relance</span>
          <Switch color="primary" onChange={handleChangeSwitch} />
          <span className={first_reminder ? "no-active" : "active2"}>2<sup>ème </sup>Relance</span>
        </div>
      )}
      <FacAmendmentReminderDetail
        first_reminder={first_reminder}
        disableButton={disableButton}
        maitreOuvrage={maitreOuvrage}
        dataFacture={dataFacture}
        clientResponse={clientResponse}
        comptableSexe={comptableSexe}
        comptableName={comptableName}
        handleDateReminderChange={handleDateReminderChange}
        handleChangeClientResponse={handleChangeClientResponse}
        handleChangeCompatbleInfos={handleChangeCompatbleInfos}
        handleSaveData={handleSaveData}
        handleGenFacAmendmentReminder={handleGenFacAmendmentReminder}
        handleShowFacAmendmentReminder={handleShowFacAmendmentReminder}
        handleGenFacAmendmentReminderTable={handleGenFacAmendmentReminderTable}
        handleShowReminderTablePDF={handleShowFacAmendmentReminderTable}
      />
      <GenPdf
        isOpen={openFile}
        file={file}
        closeDoc={closeDoc}
        scale={file !== null ? 1 : 0.5}
      />
    </div>
  );
};

export default FacAmendmentReminder;